import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { FaUser, FaUserFriends, FaIdBadge } from "react-icons/fa";
import "./RDACC.css";
import { Chart as ChartJS } from "chart.js/auto";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const RDAccountForm = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.userProfile);
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  console.log("Profile:", profile);

  // Calculation states
  const [amount, setAmount] = useState("");
  const [tenure, setTenure] = useState("");
  const [results, setResults] = useState({
    principal: 0,
    totalInterest: 0,
    maturityAmount: 0,
  });
  const [viewChart, setViewChart] = useState(false);

  // API Loading States
  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [nomineeLoading, setNomineeLoading] = useState(false);

  // Schemes
  const [schemes, setSchemes] = useState([]);
  const [selectedSchemeId, setSelectedSchemeId] = useState("");
  const [selectedScheme, setSelectedScheme] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  // Customer
  const [customerId, setCustomerId] = useState("");
  const [customerData, setCustomerData] = useState({
    name: "",
    email: "",
    phone: "",
    aadhar: "",
    pan: "",
    dob: "",
    address: "",
  });

  // Nominee
  const [nomineeId, setNomineeId] = useState("");
  const [nomineeData, setNomineeData] = useState({
    nomineeName: "",
    dob: "",
    aadhar: "",
    pan: "",
    mobile: "",
  });

  // Relation & Referral
  const [relation, setRelation] = useState("");
  const [referId, setreferId] = useState("");
  const [referralName, setReferralName] = useState("");
  const [accountType, setAccountType] = useState("RD");

  const [savingAccounts, setSavingAccounts] = useState([]);
  const [selectedSavingAccount, setSelectedSavingAccount] = useState("");
  const [deductionType, setDeductionType] = useState("manual"); // 'linked' or 'manual'

  const [openingDate, setOpeningDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    // if (profile?.id) fetchLeaves();
  }, [profile]);

  // ------------------------------------------
  // FINAL REFERRAL AUTO-FETCH USE EFFECT
  // Supports: EMP, BM, SM, AR, RM, ADM, HO, etc.
  // ------------------------------------------
  useEffect(() => {
    if (!referId) return;
    if (!profile?.superAdminId) return;

    // FINAL REGEX: supports B.M.000001, BM000001, B-M-000001, etc.
    const pattern = /^[A-Z.\-]{2,10}\d{1,10}$/;

    if (pattern.test(referId)) {
      fetchReferral(referId);
    }
  }, [referId, profile?.superAdminId]);

  // Fetch Function
  const fetchAccounts = async () => {
    const branchId = localStorage.getItem("userId") || 56;

    try {
      const res = await axios.get(
        "https://narrowitsolution.in/api/get-all-saving-account",
        {
          params: { superAdminId: profile.superAdminId, branchId: branchId },
        }
      );
      console.log("🟢 Saving Accounts API Response:", res.data);

      if (Array.isArray(res.data.accounts)) {
        setSavingAccounts(res.data.accounts);
      } else {
        setSavingAccounts([]);
      }
    } catch (err) {
      console.error("Error fetching saving accounts:", err);
    }
  };

  // Effect: Fetch when user selects "linked"
  useEffect(() => {
    if (deductionType === "linked") {
      fetchAccounts();
    }
  }, [deductionType]);

  // // Debug Effect
  // useEffect(() => {
  //   console.log("💾 Saving Accounts Loaded:", savingAccounts);
  // }, [savingAccounts]);
  //   // ====================== Fetch RD/DD Schemes ======================
  //   useEffect(() => {
  //     const fetchSchemes = async () => {
  //       setLoading(true);
  //       try {
  //         const res = await axios.get(`https://narrowitsolution.in/api/get-all-rddd?superAdminId=${profile.superAdminId}`);
  //         if (res.data?.success) setSchemes(res.data.data);
  //       } catch (err) {
  //         console.error("Error fetching schemes:", err);
  //       } finally {
  //         setLoading(false);
  //       }
  //     };
  //     fetchSchemes();
  //   }, []);

  useEffect(() => {
    if (!profile?.superAdminId) return; // wait until profile loads

    const fetchSchemes = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `https://narrowitsolution.in/api/get-all-rddd?superAdminId=${profile.superAdminId}`
        );
        console.log("rd schemes:", res.data);
        if (res.data?.success) setSchemes(res.data.data);
      } catch (err) {
        console.error("Error fetching schemes:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSchemes();
  }, [profile?.superAdminId]);

  // ====================== Handle Scheme Select ======================
  const handleSchemeSelect = (e) => {
    const schemeId = e.target.value;
    setSelectedSchemeId(schemeId);
    const scheme = schemes.find((s) => s.id === Number(schemeId));
    setSelectedScheme(scheme || null);
  };

  // ====================== Fetch Customer ======================
  const fetchCustomer = async (id) => {
    if (!id) return;
    try {
      setCustomerLoading(true);
      const branchId = localStorage.getItem("userId") || "56";
      const res = await axios.get(
        "https://narrowitsolution.in/api/customers-get-userId",
        {
          params: { userId: id, branchId },
        }
      );
      // console.log("customer rd:",res.data)

      if (res.data?.data) {
        const c = res.data.data;
        setCustomerData({
          name: c.fullName || "",
          email: c.email || "",
          phone: c.mobileNumber || "",
          aadhar: c.aadhaarNumber || "",
          pan: c.panNumber || "",
          address: c.address || "",
          dob: c.dateOfBirth ? c.dateOfBirth.split("T")[0] : "",
        });
      } else {
        toast.error("No customer found with this ID");
      }
    } catch (err) {
      console.error("Error fetching customer:", err);
      toast.error("Error fetching customer details");
    } finally {
      setCustomerLoading(false);
    }
  };

  // ====================== Fetch Nominee ======================
  const fetchNominee = async (id) => {
    if (!id) return;
    try {
      setNomineeLoading(true);
      const branchId = localStorage.getItem("userId") || "56";
      const res = await axios.get(
        "https://narrowitsolution.in/api/customer-nominee-filter",
        {
          params: { customerId: id, branchId },
        }
      );

      if (res.data.success && res.data.data) {
        const n = res.data.data;
        console.log("nominee data:", n);
        setNomineeData({
          nomineeName: n.nomineeName || "",
          dob: n.nomineeDob ? n.nomineeDob.split("T")[0] : "",
          aadhar: n.nomineeAadhar || "",
          pan: n.nomineePan || "",
          mobile: n.nomineeMobile || "",
        });
        setNomineeId(n.accountId || "");
        setRelation(n.nomineeRelation || n.relation || "");
      } else {
        setNomineeData({
          nomineeName: "",
          dob: "",
          aadhar: "",
          pan: "",
          mobile: "",
        });
      }
    } catch (err) {
      console.error("Error fetching nominee:", err);
      toast.error("Error fetching nominee details");
    } finally {
      setNomineeLoading(false);
    }
  };

  const fetchReferral = async (id) => {
    if (!id) return alert("Please enter Referral ID");

    try {
      const superAdminId = profile?.superAdminId;
      const res = await axios.get("https://narrowitsolution.in/api/hr-employees-filter", {
        params: { userId: id, superAdminId },
      });

      if (res.data.success && res.data.data) {
        const r = res.data.data;
        setReferralName(r.fullName || r.employeeName || r.name || "");
      } else {
        setReferralName("");
        toast.error("No referral found with this ID");
      }
    } catch (err) {
      console.error("Error fetching referral:", err);
      toast.error("Error fetching referral details");
      setReferralName("");
    }
  };
  // console.log("selected prefix",selectedScheme.prefix)

  // ====================== Handle Submit (API Integration) ======================
  const handleSubmit = async () => {
    if (!customerId || !selectedSchemeId || !amount)
      return toast.warn("Please fill all required fields");
    if (!profile?.superAdminId) return alert("please wait");

    const payload = {
      accountType,
      customerId,
      prefix:selectedScheme?.prefix,
      customerName: customerData.name,
      nomineeCusId: nomineeId,
      nomineeName: nomineeData.nomineeName,
      compoundingType: selectedScheme.interestCompounding,
      installmentFrequency: selectedScheme.recurringFrequency,
      relation,
      referralId: referId,
      referralName,
      schemeId: Number(selectedSchemeId),
      schemeName: selectedScheme?.serviceName || "",
      roi: Number(selectedScheme?.roi) || 0,
      lockinPeriodMonths: Number(selectedScheme?.depositLockinPeriod) || 0,
      interestLockinMonths: Number(selectedScheme?.interestLockinPeriod) || 0,
      amount: Number(amount),
      tenure: Number(tenure),
      totalInterest: results.totalInterest,
      maturityAmount: results.maturityAmount,
      superAdminId: profile.superAdminId || 14,
      branchId: localStorage.getItem("userId") || "56",
      openingDate: openingDate,
      deductionType,
      linkedSavingAccount:
        deductionType === "linked" ? Number(selectedSavingAccount) : null,
    };

    try {
      setSubmitting(true);
      const res = await axios.post(
        "https://narrowitsolution.in/api/deposit/create/banksan",
        // "https://narrowitsolution.in/api/deposit-account/create",
        // "https://narrowitsolution.in/api/deposit/create-custom",
        payload
      );

      if (res.data.success) {
        toast.success("Deposit Account Created Successfully!");
        resetForm();
      } else {
        toast.error(res.data.message || "Failed to open account");
      }
    } catch (err) {
      console.error("Error creating deposit:", err);
      toast.error("Something went wrong while creating the account");
    } finally {
      setSubmitting(false);
    }
  };

  // // Auto fetch customer + nominee
  // useEffect(() => {
  //   if (customerId) {
  //     fetchCustomer(customerId);
  //     fetchNominee(customerId);

  //   }
  // }, [customerId]);

  useEffect(() => {
    const pattern = /^CUS\d{5,10}$/;

    if (pattern.test(customerId)) {
      fetchCustomer(customerId);
      fetchNominee(customerId);
    }
  }, [customerId]);


const handleCalculate = (e) => {
  e.preventDefault();

  if (!amount || !tenure || !selectedScheme) {
    toast.warn("Please select a scheme and enter amount & tenure");
    return;
  }

  const P = Number(amount);
  const R = Number(selectedScheme.roi || 0); // annual ROI %
const rawFreq = selectedScheme.recurringFrequency || "";
const freq = rawFreq.trim().toLowerCase().replaceAll(" ", "").replaceAll("-", "");


  if (R <= 0 || P <= 0 || tenure <= 0) {
    toast.warn("Invalid input values");
    return;
  }

  let principal = 0;
  let interest = 0;
  let maturity = 0;

  const rate = R / 100;

//   if (freq.includes("daily") || freq.includes("dd")) {
//    const N = Number(tenure);
//    const annualRate = R / 100;
   
//    principal = P * N;

//    // DD Formula: Daily compounding for each deposit
//    let totalMaturity = 0;
//    const dailyRate = annualRate / 365;

//    for (let day = 1; day <= N; day++) {
//      // Days remaining for this deposit (including current day)
//      const daysRemaining = N - day + 1;
     
//      // Compound interest with daily rate: A = P × (1 + r)^t
//      const maturedAmount = P * Math.pow(1 + dailyRate, daysRemaining);
//      totalMaturity += maturedAmount;
//    }

//    maturity = totalMaturity;
//    interest = maturity - principal;
// }


// if (freq.includes("daily") || freq.includes("dd")) {

//   const P = Number(amount);
//   const N = Number(tenure);
//   const annualRate = Number(selectedScheme.roi) / 100;

//   principal = P * N;

//   let totalInterest = 0;

//   // Quarterly compounding rate
//   const quarterlyRate = annualRate / 4;

//   for (let k = 1; k <= N; k++) {

//     const daysRemaining = N - k + 1;

//     // Fractional quarters
//     const quarters = (daysRemaining / 365) * 4;

//     // Quarterly compounding
//     const maturedAmount = P * Math.pow(1 + quarterlyRate, quarters);

//     totalInterest += (maturedAmount - P);
//   }

//   interest = totalInterest;
//   maturity = principal + totalInterest;
// }


if (freq.includes("daily") || freq.includes("dd")) {

  const P = Number(amount);    
  const N = Number(tenure);    
  const annualRate = Number(selectedScheme.roi) / 100;

  principal = P * N;

  let totalInterest = 0;

  // Quarterly compounding rate
  const quarterlyRate = annualRate / 4;

  for (let k = 1; k <= N; k++) {

    const daysRemaining = N - k + 1;

    // IMPORTANT FIX: Use 90 days per quarter (NOT 365/4)
    const quarters = daysRemaining / 91;

    // Quarterly compounding
    const maturedAmount = P * Math.pow(1 + quarterlyRate, quarters);

    totalInterest += (maturedAmount - P);
  }

  interest = totalInterest;
  maturity = principal + totalInterest;
}

// weekly
else if (freq.includes("weekly") || freq.includes("ww")) {

  const P = Number(amount);        // Weekly deposit
  const N = Number(tenure);        // Number of weeks
  const annualRate = Number(selectedScheme.roi) / 100;

  principal = P * N;

  let totalInterest = 0;

  // Quarterly compounding rate
  const quarterlyRate = annualRate / 4;

  for (let k = 1; k <= N; k++) {

    const weeksRemaining = N - k + 1;

    // 13 weeks per quarter
    const quarters = weeksRemaining / 13;

    const maturedAmount = P * Math.pow(1 + quarterlyRate, quarters);

    totalInterest += (maturedAmount - P);
  }

  interest = totalInterest;
  maturity = principal + totalInterest;
}



  // =====================================================================
  // ⭐ MONTHLY RD
  // =====================================================================
  else if (freq === "monthly") {

  const P = Number(amount);        // 3000
  const n = Number(tenure);        // 60 months
  const R = Number(selectedScheme.roi); // 8.5%

  const i = R / 1200; // monthly rate

  // GROW / SBI standard RD formula
  const maturityCalc =
    P * ((Math.pow(1 + i, n) - 1) / (1 - Math.pow(1 + i, -1)));

  principal = P * n;
  interest = maturityCalc - principal;
  maturity = maturityCalc;
}

  // =====================================================================
  // ⭐ QUARTERLY RD
  // =====================================================================
  else if (freq === "quarterly") {
    const n = Number(tenure);
    const quarterlyRate = rate / 4;

    const maturityCalc =
      P *
      ((Math.pow(1 + quarterlyRate, n) - 1) /
        (1 - Math.pow(1 + quarterlyRate, -1)));

    principal = P * n;
    interest = maturityCalc - principal;
    maturity = maturityCalc;
  }

  // =====================================================================
  // ⭐ YEARLY RD
  // =====================================================================
  else if (freq === "yearly") {
    const n = Number(tenure);

    const maturityCalc =
      P *
      ((Math.pow(1 + rate, n) - 1) /
        (1 - Math.pow(1 + rate, -1)));

    principal = P * n;
    interest = maturityCalc - principal;
    maturity = maturityCalc;
  }

  // =====================================================================
  // ⭐ UNKNOWN FREQUENCY
  // =====================================================================
  else {
    toast.error(`Unknown frequency: ${selectedScheme.recurringFrequency}`);
    return;
  }

  // =====================================================================
  // 🔥 UPDATE UI
  // =====================================================================
  setResults({
    principal: principal.toFixed(2),
    totalInterest: interest.toFixed(2),
    maturityAmount: maturity.toFixed(2),
  });
};

  // ====================== ChartJS ======================
  useEffect(() => {
    if (viewChart && canvasRef.current) {
      if (chartRef.current) chartRef.current.destroy();

      chartRef.current = new ChartJS(canvasRef.current, {
        type: "doughnut",
        data: {
          labels: ["Principal", "Interest"],
          datasets: [
            {
              data: [results.principal, results.totalInterest],
              backgroundColor: ["#018da0ff", "#F59E0B"],
              hoverOffset: 10,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: { legend: { position: "bottom" } },
        },
      });
    }

    return () => {
      if (chartRef.current) chartRef.current.destroy();
    };
  }, [viewChart, results]);

  // ====================== Reset ======================
  const resetForm = () => {
    setAmount("");
    setTenure("");
    setResults({ principal: 0, totalInterest: 0, maturityAmount: 0 });
    setViewChart(false);
    setCustomerId("");
    setCustomerData({
      name: "",
      email: "",
      phone: "",
      aadhar: "",
      pan: "",
      dob: "",
      address: "",
    });
    setNomineeId("");
    setNomineeData({
      nomineeName: "",
      dob: "",
      aadhar: "",
      pan: "",
      mobile: "",
    });
    setRelation("");
    setreferId("");
    setReferralName("");
    setSelectedSchemeId("");
    setSelectedScheme(null);
  };

  // ====================== UI ======================
  return (
    <div className="rd-dd-container">
      {/* ===== Account Details Section ===== */}
      <h2 className="rd-dd-heading">
        {accountType === "RD"
          ? "RD Account Form"
          : "DD Account Form"}
      </h2>
      <form onSubmit={handleCalculate}>
        <div className="rd-dd-form-section">

        <h3>ACCOUNT INFORMATION</h3>
        <div className="rd-dd-form-grid">
          {/* Account Type */}
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Account Type</label>
            <select
              id="accountType"
              value={accountType}
              onChange={(e) => setAccountType(e.target.value)}
              className="rd-dd-input"
            >
              <option value="RD">RD Account</option>
              <option value="DD">DD Account</option>
            </select>
          </div>

          {/* Scheme Dropdown */}
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Select Scheme :</label>
            <select
              className="rd-dd-input"
              value={selectedSchemeId}
              onChange={handleSchemeSelect}
            >
              <option value="">-- Select Scheme --</option>
              {loading ? (
                <option disabled>Loading...</option>
              ) : (
                schemes.map((scheme) => (
                  <option key={scheme.id} value={scheme.id}>
                    {scheme.serviceName} ({scheme.recurringFrequency})
                  </option>
                ))
              )}
            </select>
          </div>

          {/* Scheme Info Fields */}
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">ROI (%):</label>
            <input
              type="text"
              value={selectedScheme?.roi || ""}
              readOnly
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Min Deposit Amount:</label>
            <input
              type="text"
              value={selectedScheme?.minDepositInstallment || ""}
              readOnly
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Min Tenure:</label>
            <input
              type="text"
              value={selectedScheme?.minTenure || ""}
              readOnly
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Installment Frequency:</label>
            <input
              type="text"
              value={selectedScheme?.recurringFrequency || ""}
              readOnly
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Lockin Period (Months):</label>
            <input
              type="text"
              value={selectedScheme?.depositLockinPeriod || ""}
              readOnly
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Interest Lockin (Months):</label>
            <input
              type="text"
              value={selectedScheme?.interestLockinPeriod || ""}
              readOnly
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Compounding Type:</label>
            <input
              type="text"
              value={selectedScheme?.interestCompounding || ""}
              readOnly
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Opening Date:</label>
            <input
              type="date"
              value={openingDate}
              onChange={(e) => setOpeningDate(e.target.value)}
              className="rd-dd-input"
            />
          </div>

          {/* User Inputs */}
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Enter Deposit Amount:</label>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="rd-dd-input"
            />
          </div>
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Enter Tenure:</label>
            <input
              type="number"
              value={tenure}
              onChange={(e) => setTenure(e.target.value)}
              className="rd-dd-input"
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="RDACCbtn-actions">
          <button type="submit" className="RDACCbtn-calc">
            Calculate
          </button>
          <button type="button" className="RDACCbtn-reset" onClick={resetForm}>
            Reset
          </button>

          <label className="RDACCchart-toggle">
            <input
              type="checkbox"
              checked={viewChart}
              onChange={(e) => setViewChart(e.target.checked)}
            />
            <span className="RDACCslider"></span>
            <span className="RDACCtoggle-label">
              {viewChart ? "View" : "Close"} Chart
            </span>
          </label>
        </div>

               </div>
      </form>

      {/* ===== Result Section ===== */}
      <div className="RDACC-result card">
        <div className="RDACCcard-header">Results</div>
        <div className="RDACCresults-grid">
          <div className="RDACCresults-info">
            <div className="RDACCresult-row">
              <div className="RDACClabel">Principal Amount:</div>
              <div className="RDACCvalue">
                {results.principal.toLocaleString()}
              </div>
            </div>
            <div className="RDACCresult-row">
              <div className="RDACClabel">Total Interest:</div>
              <div className="RDACCvalue">
                {results.totalInterest.toLocaleString()}
              </div>
            </div>
            <div className="RDACCresult-row">
              <div className="RDACClabel">Maturity Amount:</div>
              <div className="RDACCvalue">
                {results.maturityAmount.toLocaleString()}
              </div>
            </div>
          </div>
          {viewChart && (
            <div className="RDACCchart-wrap">
              <canvas ref={canvasRef} className="RDACC-canvas"></canvas>
            </div>
          )}
        </div>
      </div>
      <section className="RDACCNom-card">
        <h3>
          <FaUser /> Customer Details
        </h3>
        <div className="RDACCNom-grid">
          {" "}
          <div>
            <label>Customer ID:</label>{" "}
            <input
              type="text"
              placeholder="Enter Customer ID"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
            />
          </div>
          <div>
            <label>User Name:</label>
            <input
              type="text"
              value={customerData.name}
              onChange={(e) =>
                setCustomerData({ ...customerData, name: e.target.value })
              }
            />
          </div>
          <div>
            <label>Email:</label>
            <input
              type="email"
              value={customerData.email}
              onChange={(e) =>
                setCustomerData({ ...customerData, email: e.target.value })
              }
            />
          </div>
          <div>
            <label>Phone:</label>
            <input
              type="text"
              value={customerData.phone}
              onChange={(e) =>
                setCustomerData({ ...customerData, phone: e.target.value })
              }
            />
          </div>
          <div>
            <label>Aadhar:</label>
            <input
              type="text"
              value={customerData.aadhar}
              onChange={(e) =>
                setCustomerData({ ...customerData, aadhar: e.target.value })
              }
            />
          </div>
          <div>
            <label>PAN:</label>
            <input
              type="text"
              value={customerData.pan}
              onChange={(e) =>
                setCustomerData({ ...customerData, pan: e.target.value })
              }
            />
          </div>
          <div>
            <label>Date of Birth:</label>
            <input
              type="date"
              value={customerData.dob}
              onChange={(e) =>
                setCustomerData({ ...customerData, dob: e.target.value })
              }
            />
          </div>
          {/* <div className="RDACCfull-width"> */}
          <div className="RDACCfull-width">
            <label>Address:</label>
            <input
              className="RDACCfull-width-input"
              type="text"
              value={customerData.address}
              onChange={(e) =>
                setCustomerData({ ...customerData, address: e.target.value })
              }
            />
          </div>
        </div>
        {/* </div> */}
      </section>

      {/* ===== Nominee Details (2 fields per row) ===== */}
      <section className="RDACCNom-card">
        <h3>
          <FaUserFriends /> Nominee Details
        </h3>

        <div className="RDACCNom-grid">
          <div>
            <label>Nominee ID:</label>
            <input
              type="text"
              placeholder="Enter Nominee ID"
              value={nomineeId}
              onChange={(e) => setNomineeId(e.target.value)}
            />
          </div>

          <div>
            <label>Nominee Name:</label>
            <input
              type="text"
              value={nomineeData.nomineeName}
              onChange={(e) =>
                setNomineeData({
                  ...nomineeData,
                  nomineeName: e.target.value,
                })
              }
            />
          </div>

          <div>
            <label>DOB:</label>
            <input
              type="date"
              value={nomineeData.dob}
              onChange={(e) =>
                setNomineeData({ ...nomineeData, dob: e.target.value })
              }
            />
          </div>

          <div>
            <label>Aadhar:</label>
            <input
              type="text"
              value={nomineeData.aadhar}
              onChange={(e) =>
                setNomineeData({ ...nomineeData, aadhar: e.target.value })
              }
            />
          </div>

          <div>
            <label>PAN:</label>
            <input
              type="text"
              value={nomineeData.pan}
              onChange={(e) =>
                setNomineeData({ ...nomineeData, pan: e.target.value })
              }
            />
          </div>

          <div>
            <label>Mobile:</label>
            <input
              type="text"
              value={nomineeData.mobile}
              onChange={(e) =>
                setNomineeData({ ...nomineeData, mobile: e.target.value })
              }
            />
          </div>

          <div>
            <label>Relation:</label>
            <select
              value={relation}
              onChange={(e) => setRelation(e.target.value)}
            >
              <option value="">Select</option>
              {["Father", "Mother", "Spouse", "Son", "Daughter", relation]
                .filter((r, i, arr) => r && arr.indexOf(r) === i) // remove duplicates
                .map((r) => (
                  <option key={r} value={r}>
                    {r}
                  </option>
                ))}
            </select>
          </div>
        </div>

        {/* Deduction Type Selector */}
        <div className="rd-dd-input-group" style={{marginTop:"15px"}}>
          <label className="rd-dd-label">Deduction Type:</label>
          <select
            value={deductionType}
            onChange={(e) => setDeductionType(e.target.value)}
            className="rd-dd-input"
          >
            <option value="manual">Manual Deposit</option>
            <option value="linked">Deduct from Saving Account</option>
          </select>
        </div>

        {/* Show Saving Account Dropdown if Linked Selected */}
        {deductionType === "linked" && (
          <div className="rd-dd-input-group">
            <label className="rd-dd-label">Select Saving Account:</label>
            <select
              value={selectedSavingAccount}
              onChange={(e) => setSelectedSavingAccount(e.target.value)}
              className="rd-dd-input"
            >
              <option value="">-- Select Saving Account --</option>
              {savingAccounts.map((acc) => (
                <option key={acc.id} value={acc.id}>
                  {acc.accountNumber}-{acc.customerName}—₹
                  {acc.currentBalance?.toLocaleString()}
                </option>
              ))}
            </select>
          </div>
        )}
      </section>

      {/* ✅ Submit Button */}
      <section className="RDACCRef-card">
        <h3>
          <FaIdBadge /> Referral Details
        </h3>
        {/* <div className="RDACCRef-row-horizontal">
          <div>
            <label className="referral-name">Referral ID : </label>
            <input
              className="referral-input"
              type="text"
              placeholder="Enter Referral ID"
              value={referId}
              onChange={(e) => setreferId(e.target.value)}
            />
          </div>

          <div>
            <label className="referral-name">Referral Name : </label>
            <input
              className="referral-input"
              type="text"
              value={referralName}
              readOnly
              placeholder="Auto-filled after ID"
            />
          </div>
        </div> */}

        <div className="RDACCRef-row-horizontal">
    <div>
      <label>Referral ID:</label>
      <input
        type="text"
        placeholder="Enter Referral ID (e.g. EMP56000123)"
        value={referId}
        onChange={(e) => setreferId(e.target.value)}
      />
    </div>

    <div>
      <label >Referral Name:</label>
      <input
        type="text"
        value={referralName}
        readOnly
        placeholder="Auto-filled after ID"
      />
    </div>
  </div>
      </section>
      <div style={{ textAlign: "center" }}>
        <button
          type="button"
          className="RDACCubmit-btn"
          disabled={submitting}
          onClick={handleSubmit}
        >
          {submitting ? "Opening..." : `Open ${accountType} Account`}
        </button>
      </div>

      {/* ===== Customer, Nominee, Referral Sections remain as per your design ===== */}
    </div>
  );
};

export default RDAccountForm;